import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { isPortalApiUrl, isPortalUserAccessDenied } from '../portal-access-error';
import { SecurityService } from '../security.service';

@Injectable()
export class PortalAccessInterceptor implements HttpInterceptor {
  private redirectInProgress = false;

  constructor(private securityService: SecurityService, private router: Router) { }

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(tap({
      error: error => {
        if (!isPortalApiUrl(request.url) || !isPortalUserAccessDenied(error)) {
          return;
        }

        this.securityService.setPortalAccess(null);
        this.securityService.setCurrentAccount(null);

        if (this.redirectInProgress || this.router.url.split(/[?#]/)[0] === '/security') {
          return;
        }

        this.redirectInProgress = true;
        void this.router.navigate(['/security'], { replaceUrl: true }).catch(error => {
          console.error('Could not navigate to the access denied page.', error);
        }).finally(() => {
          this.redirectInProgress = false;
        });
      }
    }));
  }
}
